import { render, staticRenderFns } from "./individualPayment.vue?vue&type=template&id=640826c8&"
import script from "./individualPayment.vue?vue&type=script&lang=js&"
export * from "./individualPayment.vue?vue&type=script&lang=js&"
import style0 from "./individualPayment.vue?vue&type=style&index=0&id=640826c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports